import { UseQueryResult } from '@tanstack/react-query';
import { Button } from 'components/atoms';
import { FormInput } from 'components/molecules';
import { useStreamFileDownload } from 'hooks/useStreamFileDownload';
import { useTranslation } from 'react-i18next';
import { PiDownload } from 'react-icons/pi';
import { useGetSettlementLightList } from 'services/settlementPeriods';
import { getSettlementPeriodName } from 'utils/global/name.utils';
import { object, string } from 'yup';
import PopupForm from '../form/PopupForm';

interface IDownloadFilesInPeriodPopupProps {
  service: (id: string, enabled?: boolean) => UseQueryResult<Blob, Error>;
  filePrefix: string;
}

const DownloadFilesInPeriodPopup = ({
  service,
  filePrefix,
}: IDownloadFilesInPeriodPopupProps) => {
  const settlementPeriods = useGetSettlementLightList();
  const { setFile, isLoading } = useStreamFileDownload(service);
  const { t } = useTranslation();
  return (
    <PopupForm
      header={
        <>
          <PiDownload /> {filePrefix}
        </>
      }
      trigger={
        <Button onlyIcon isClear>
          <Button.Description description={t('button.download')} />
          <Button.Icon icon={<PiDownload />} />
        </Button>
      }
      validationSchema={object().shape({
        settlementPeriodId: string().required(t('formik-error.required')),
      })}
      initialStatus={{ isLoading: isLoading }}
      onSubmit={(values, formikHelpers, actions) => {
        setFile({
          id: values.settlementPeriodId,
          name: `${filePrefix.toLocaleLowerCase()}_${values.settlementPeriodName
            .replaceAll(' ', '_')
            .toLocaleLowerCase()}`,
          extension: 'zip',
        });
        formikHelpers.resetForm();
        actions?.close();
      }}
      initialValues={{ settlementPeriodId: '', settlementPeriodName: '' }}>
      {({ setFieldValue }) => (
        <FormInput.Select
          name='settlementPeriodId'
          label={t('input.label.settlementPeriodId')}
          onChange={o => {
            setFieldValue('settlementPeriodName', o.label);
          }}
          options={settlementPeriods.data?.map(p => ({
            label: getSettlementPeriodName(p.settlementPeriodName),
            value: p.id,
          }))}
        />
      )}
    </PopupForm>
  );
};

export default DownloadFilesInPeriodPopup;
